<template>
  <div id="app_signup">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-8>
        <v-card id="app_height" outlined tile>
          <v-layout wrap pt-4 justify-center>
            <v-flex xs12 md2 align="center">
              <!-- <router-link to="/">
                <v-img src="../../assets/icons/back.png" aspect-ratio="1" contain height="50px"></v-img>
              </router-link> -->
            </v-flex>
            <v-flex xs12 md8 text-center align-self-end>
              <span class="login_head">LEOPARD TECH LABS</span>
            </v-flex>
            <v-flex md2></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex text-center>
              <span
                style="font-size:12px;font-weight:400;color:#a9a9a9;"
              >You have signed in as Administrator</span>
            </v-flex>
          </v-layout>
          <!-- {{msg}} -->
          <ProfileDetails v-bind:profileData="profileData" />
          <!-- <registrationDetails v-bind:profileData="profileData" /> -->
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import ProfileDetails from "@/components/Profile/ProfileDetails";
// import registrationDetails from "./../Profile/registrationDetails";
// import axios from "axios";
import VueElementLoading from "vue-element-loading";

export default {
  components: {
    ProfileDetails,
    // registrationDetails,
    VueElementLoading
  },
  data() {
    return {
      
    //   msg: null,
     
      appLoading: false
    };
  },
  beforeMount() {
    // this.getProfile();
  },
  
};
</script>
<style scoped>
#app_signup {
  background-color: #2c3341;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 91vh;
  }
}
</style>